<template>
    <v-container fluid>
        <!--table head-->
        <v-row class="my-2 subtitle-2 secondary--text pl-12">
            Independent chains
        </v-row>
        <v-divider />
        <v-row class="subtitle-2 text-center" no-gutters>
            <v-col v-for="(item, i) in headers" :key="i" class="tabCell">
                {{ item }}
            </v-col>
        </v-row>
        <div v-if="chains?.length">
            <!--chain tab-->
            <v-row v-if="onlineMarketplaces.length" class="subtitle-2 secondary--text my-2" no-gutters>Online marketplaces</v-row>
            <v-row v-for="chain in onlineMarketplaces" :key="chain.id" no-gutters>
                <v-col class="tabCell text-left text-truncate">{{ chain.name }}</v-col>
                <v-col class="tabCell text-center">{{ chain.stores }}</v-col>
                <v-col class="tabCell text-center">{{ localeNumber(chain.peak_market_coverage) }}</v-col>
                <v-col class="tabCell text-center">{{ localeNumber(chain.peak_market_coverage * chain.stores) }}</v-col>
                <v-col class="tabCell text-center">{{ localeNumber(chain.entry_fee) }}</v-col>
                <v-col class="tabCell text-center">{{ localeNumber(chain.annual_fee) }}</v-col>
                <v-col class="tabCell text-center">{{ chain.retail_margin }}</v-col>
                <v-col class="tabCell text-center">{{ chain.num_trademarks }}</v-col>
                <v-col class="tabCell text-center">{{ chain.min_price }}</v-col>
                <v-col class="tabCell text-center">{{ chain.max_price }}</v-col>
                <v-col class="tabCell text-center">{{ chain.design_main }}</v-col>
                <v-col class="tabCell text-center">{{ chain.design_second }}</v-col>
                <v-col class="tabCell text-center">
                    <edit-chain :chain="chain" />
                    <delete-chain :chain="chain" />
                </v-col>
            </v-row>
            <v-row class="subtitle-2 secondary--text my-2" no-gutters>Independent brick & mortar stores</v-row>
                <v-row v-for="chain in marketplaces" :key="chain.id" no-gutters>
                    <v-col class="tabCell text-left text-truncate">{{ chain.name }}</v-col>
                    <v-col class="tabCell text-center">{{ chain.stores }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(chain.peak_market_coverage) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(chain.peak_market_coverage * chain.stores) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(chain.entry_fee) }}</v-col>
                    <v-col class="tabCell text-center">{{ localeNumber(chain.annual_fee) }}</v-col>
                    <v-col class="tabCell text-center">{{ chain.retail_margin }}</v-col>
                    <v-col class="tabCell text-center">{{ chain.num_trademarks }}</v-col>
                    <v-col class="tabCell text-center">{{ chain.min_price }}</v-col>
                    <v-col class="tabCell text-center">{{ chain.max_price }}</v-col>
                    <v-col class="tabCell text-center">{{ chain.design_main }}</v-col>
                    <v-col class="tabCell text-center">{{ chain.design_second }}</v-col>
                    <v-col class="tabCell text-center">
                        <edit-chain :chain="chain" />
                        <delete-chain :chain="chain" />
                    </v-col>
                </v-row>
        </div>
        <v-row v-else>
            There are no chain yet
        </v-row>
    </v-container>
</template>
<script>
import EditChain from '../../../components/admin/chains/editChain.vue'
import DeleteChain from '../../../components/admin/chains/deleteChain.vue'

export default {
    name: 'MarketDesign',
    data() {
        return {
            headers: [
                'Available channels',
                'Store count',
                'Peak market coverage 1 store',
                'Peak market coverage entire chain',
                'Entry fee',
                'Annual flat fee',
                'Target retail margin',
                'Number of trademarks',
                'Min preferable price',
                'Max preferable price',
                'Main design' ,
                'Second design',
                'Action'
            ],
        }
    },
    computed: {
        locale() {
            return this.$store.getters.locale;
        },
        chains() {
            return this.$store.getters.chains
        },
        onlineMarketplaces() {
            return this.$store.getters.chains?.filter(chan => chan.type === 'online')
        },
        marketplaces() {
            return this.$store.getters.chains?.filter(chan => chan.type === 'brick&mortar')
        }
    },
    methods: {
        localeNumber(num) {
            if (this.locale == 'ro-RO') {
                return num.toLocaleString('en-US')
            }
            return num.toLocaleString(this.locale)
        }
    },
    components: {
        EditChain,
        DeleteChain
    }
}
</script>